<!-- Created by henian.xu on 2020/7/9. -->

<template>
    <Page>
        <PageBar
            v-if="applyDetail.trainingGroupingQrCodeUrl"
            direction="column">
            <Tab
                average
                @change="onTabChange">
                <TabPanel
                    label="从业学员学习群"
                    sign="student"
                ></TabPanel>
                <TabPanel
                    label="培训班级学习群"
                    sign="training"
                ></TabPanel>
            </Tab>
        </PageBar>
        <Container
            v-if="tabSign==='training'"
            fill>
            <div
                v-if="applyDetail.trainingGroupingQrCodeUrl"
                class="qrcode-wrap"
            >
                <div class="header">
                    <div class="label">{{applyDetail.trainingGroupingName}}</div>
                    <div class="desc">学习群</div>

                </div>
                <XImage
                    width="50%"
                    :aspect-ratio="1"
                    :src="applyDetail.trainingGroupingQrCodeUrl"
                ></XImage>
                <div class="footer">
                    <div class="label">长按识别二维码立即加入</div>
                    <div class="desc">和同学一起交流学习，请教更顺利哦!</div>
                    <div
                        v-if="teacherInfo"
                        class="desc">班主任电话：<span v-if="teacherInfo.name">{{teacherInfo.name}}</span> <a
                            v-if="teacherInfo.tel"
                            class="tc-primary"
                            :href="`tel://${teacherInfo.tel}`">{{teacherInfo.tel}}</a>（微信同号）</div>
                </div>
            </div>
            <div
                v-else-if="!detail.isNull"
                class="qrcode-wrap"
            >
                <div class="header">
                    <div class="desc">糟糕，学习群还未建立</div>
                    <div class="desc">请联系老师建立学习群</div>
                </div>
                <XImage
                    width="50%"
                    :aspect-ratio="1"
                    :src="customerImage"
                ></XImage>
                <div class="footer">
                    <div class="desc">长按识别二维码添加老师微信</div>
                    <div
                        v-if="teacherInfo"
                        class="desc">班主任电话：<span v-if="teacherInfo.name">{{teacherInfo.name}}</span> <a
                            v-if="teacherInfo.tel"
                            class="tc-primary"
                            :href="`tel://${teacherInfo.tel}`">{{teacherInfo.tel}}</a>（微信同号）</div>
                </div>
            </div>
        </Container>
        <Container
            v-else
            fill>
            <div
                v-if="applyDetail.groupQrCodeUrl"
                class="qrcode-wrap"
            >
                <div class="header">
                    <div class="label">{{applyDetail.certCatName}}</div>
                    <div class="desc">学习群</div>

                </div>
                <XImage
                    width="50%"
                    :aspect-ratio="1"
                    :src="applyDetail.groupQrCodeUrl"
                ></XImage>
                <div class="footer">
                    <div class="label">长按识别二维码立即加入</div>
                    <div class="desc">和同学一起交流学习，请教更顺利哦!</div>
                    <div
                        v-if="teacherInfo"
                        class="desc">班主任电话：<span v-if="teacherInfo.name">{{teacherInfo.name}}</span> <a
                            v-if="teacherInfo.tel"
                            class="tc-primary"
                            :href="`tel://${teacherInfo.tel}`">{{teacherInfo.tel}}</a>（微信同号）</div>
                </div>
            </div>
            <div
                v-else-if="!detail.isNull"
                class="qrcode-wrap"
            >
                <div class="header">
                    <div class="desc">糟糕，学习群还未建立</div>
                    <div class="desc">请联系老师建立学习群</div>
                </div>
                <XImage
                    width="50%"
                    :aspect-ratio="1"
                    :src="customerImage"
                ></XImage>
                <div class="footer">
                    <div class="desc">长按识别二维码添加老师微信</div>
                    <div
                        v-if="teacherInfo"
                        class="desc">班主任电话：<span v-if="teacherInfo.name">{{teacherInfo.name}}</span> <a
                            v-if="teacherInfo.tel"
                            class="tc-primary"
                            :href="`tel://${teacherInfo.tel}`">{{teacherInfo.tel}}</a>（微信同号）</div>
                </div>
            </div>
        </Container>
        <PageBar
            v-if="tabSign==='training'&&applyDetail.isShowClassNoticeImage"
            position="bottom">
            <XButton
                label="查看办班通知"
                class="item"
                theme="main"
                @click="onViewNotice"
            ></XButton>
        </PageBar>
    </Page>
</template>

<script>
import { mapGetters } from 'vuex';
import Url from 'url';
import Qs from 'qs';

export default {
    name: 'Learn',
    data() {
        return {
            certExamApplyId: this.$route.params.id,
            detail: { isNull: true },
            tabSign: 'student',
        };
    },
    computed: {
        ...mapGetters('PortalInfo', ['customerImage']),
        applyDetail() {
            return this.detail.applyDetail || {};
        },
        teacherInfo() {
            if (!this.applyDetail.teacherTel) return null;
            const [, name, tel] =
                this.applyDetail.teacherTel.match(/^(?:([\u4E00-\u9FA5A-Za-z\s]+?)\s+)?([\d\s+]+)$/) || [];
            // const arr = '1888888  8888'.match(/^(?:([\u4E00-\u9FA5A-Za-z\s]+?)\s+)?([\d\s+]+)$/);
            return { name, tel: tel || this.applyDetail.teacherTel };
        },
    },
    methods: {
        async getDetail() {
            const { data } = await this.$api.Member.Ce.CertExamApply.applyDetail(this.certExamApplyId);
            this.detail = data || {};
        },
        onTabChange({ sign }, index) {
            console.log(sign, index);
            this.tabSign = sign;
        },
        onViewNotice() {
            const { certExamApplyId } = this;
            if (!certExamApplyId) return;
            const baseUri = Url.parse(window.location.href.split('#')[0]);
            baseUri.pathname = `${
                this.$globalVar.isDev ? this.$globalVar.appConfig.AXIOS_DEFAULT_CONFIG.baseURL : '/rpc'
            }/comm/rs/jasper/previewTrainingNotice`;
            baseUri.search = Qs.stringify({ certExamApplyId });
            const classNoticeImageUrl = baseUri.format();
            this.$wxSDK.previewImage(classNoticeImageUrl, [classNoticeImageUrl]).catch(() => {
                console.log('onListItem: 目前仅支持微信预览');
                // window.open(classNoticeImageUrl, '_blank');
                window.location.href = classNoticeImageUrl;
            });
        },
    },
    created() {
        this.getDetail();
    },
};
</script>

<style lang="scss">
.qrcode-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: $margin-big * 5;

    > .header {
        margin-bottom: $margin-big;
        > .label {
            font-size: $big * 100%;
            font-weight: bold;
            margin-bottom: $margin-small;
        }
    }
    > .footer {
        margin-top: $margin-big;
        > .desc {
            margin-top: $margin;
            color: $color-text-minor;
        }
    }
}
</style>
